import type { ReactElement } from "react";
import { useState } from "react";
import * as React from "react";
import classNames from "components/ui/classNames";
import { Popover, PopoverContentWithoutPortal, PopoverTrigger } from "components/ui/Popover";
import { EllipsisIcon } from "lucide-react";

interface ActionsDropdownChildrenState {
  closeOnClick: (onClick: () => void) => () => void;
}

interface ActionsDropdownProps {
  className?: string;
  align?: "start" | "center" | "end";
  children: (state: ActionsDropdownChildrenState) => ReactElement;
}

export default function ActionsDropdown({ className, align = "center", children }: ActionsDropdownProps) {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  return (
    <Popover open={isOpen} onOpenChange={setIsOpen}>
      <PopoverTrigger
        className={classNames(
          "m-0 box-border flex cursor-pointer items-center justify-center",
          "rounded border border-transparent bg-transparent p-1 text-slate-400 outline-none",
          "hover:bg-slate-100 hover:text-slate-400/70",
          "dark:hover:bg-slate-950 dark:hover:text-slate-300",
          className,
        )}
      >
        <EllipsisIcon className="size-6" />
      </PopoverTrigger>
      <PopoverContentWithoutPortal
        hideWhenDetached={true}
        className="rounded-xl shadow-xl dark:border-slate-900 dark:shadow-md dark:shadow-slate-900"
        align={align}
      >
        {children({
          closeOnClick: (onClick) => {
            return () => {
              if (onClick && typeof onClick === "function") {
                onClick();
                setIsOpen(false);
              }
            };
          },
        })}
      </PopoverContentWithoutPortal>
    </Popover>
  );
}
